export const tabsNamesTranslatePaths = {
  all_devices: 'manage_devices.tabs.all_devices',
  my_devices: 'manage_devices.tabs.my_devices',
  add_device: 'manage_devices.tabs.add_device',
};
